/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Status_Athlete_Finished_With_FeedbackInputs */

const fr_session_status_athlete_finished_with_feedback = /** @type {(inputs: Session_Status_Athlete_Finished_With_FeedbackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé avec feedback`)
};

/**

* @param {Session_Status_Athlete_Finished_With_FeedbackInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const session_status_athlete_finished_with_feedback = /** @type {((inputs?: Session_Status_Athlete_Finished_With_FeedbackInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Status_Athlete_Finished_With_FeedbackInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_session_status_athlete_finished_with_feedback(inputs)
});